import { useTheme } from 'foundations-theming/utils';
import { List } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import classNames from 'classnames';
import I18n from 'I18n';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
const FilterOperatorMultiStringInput = ({
  disabled,
  'data-selenium-test': seleniumSelector,
  error,
  inputUse,
  multiCollapseLimit,
  onChange,
  onBlur,
  readOnly,
  value
}) => {
  const trellisTheme = useTheme();
  const onBlurLocal = () => {
    if (typeof onBlur === 'function') {
      onBlur();
    }
  };
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: error.get('error'),
    validationMessage: error.get('error') ? error.get('message') : null,
    children: /*#__PURE__*/_jsx(Select, {
      allowCreate: true
      // Select has a dark mode option, but because we use a multi select
      // with the option to add new values, the Select has an anchorType of
      // combined, of which the given dark mode does not work on.
      // Thus the need to manually set the background color.
      ,
      cssStyles: inputUse === 'on-dark' ? {
        backgroundColor: trellisTheme.color['fill-surface-default']
      } : undefined
      // Selects without an anchor type must use className selenium selectors
      ,
      "data-test-id": classNames(seleniumSelector),
      disabled: disabled,
      multi: true,
      multiCollapseLimit: multiCollapseLimit,
      noResultsText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.resultsText"
      }),
      onClose: onBlurLocal,
      onChange: evt => onChange(syntheticEvent(List(evt.target.value))),
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.placeholder"
      }),
      promptTextCreator: userInput => unescapedText('customerDataFiltersUI.customerDataFilters.FilterOperatorMultiStringInput.promptText', {
        value: userInput
      }),
      readOnly: readOnly,
      value: value && value.toArray() || []
    })
  });
};
export default FilterOperatorMultiStringInput;